import { render, staticRenderFns } from "./TimelineYearItem.vue?vue&type=template&id=2d139a2f&scoped=true&"
import script from "./TimelineYearItem.vue?vue&type=script&lang=js&"
export * from "./TimelineYearItem.vue?vue&type=script&lang=js&"
import style0 from "./TimelineYearItem.vue?vue&type=style&index=0&id=2d139a2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d139a2f",
  null
  
)

export default component.exports